import { Divider, Pagination, Card } from 'antd';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../methods/redux/hooks';
import { getLoanReport } from '../../../methods/redux/reducers/accountant-report';
import remakeQueryString from '../../../methods/utils/remake-query-string';
import TransactionItem from '../../../transactions/transaction-statments/TransactionItem';
import AccountantsDateSelector from '../DateSelector';
import DownloadCSV from '../DownloadCSV';

const Style = styled(Card)``;

const LoanAccountantReport = () => {
	const dispatch = useAppDispatch();

	const [searchParams, setSearchParams] = useSearchParams();

	const { loan } = useAppSelector((store) => store.accountantsReport);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(
				getLoanReport({
					...queryData,
				})
			);
		}
	}, [searchParams]);

	return (
		<Style>
			<h1>Loan Report</h1>

			<Divider />

			<AccountantsDateSelector onGetReport={updateQueryString} />

			{loan.record.itemsList.length > 0 && (
				<>
					<Divider />

					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={loan.record.paginator.itemCount}
						current={loan.record.paginator.currentPage}
						pageSize={loan.record.paginator.perPage}
					/>

					<br />

					<div>
						<DownloadCSV title="loan" csv={loan.record?.reportCSVFile} />
					</div>

					<br />

					{loan.record.itemsList.map((item: any) => (
						<TransactionItem key={item._id} transaction={item} />
					))}

					<Divider />
					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={loan.record.paginator.itemCount}
						current={loan.record.paginator.currentPage}
						pageSize={loan.record.paginator.perPage}
					/>
				</>
			)}
		</Style>
	);
};

export default LoanAccountantReport;
